import { Component, OnInit } from '@angular/core';

import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '@fcom/core/interfaces';
import { profileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors';
import { finShare } from '@fcom/rx/operators/finShare';
import { CorporateUserRole } from '@fcom/core-api/login';

@Component({
  selector: 'fin-corporate-company',
  templateUrl: './corporate-company.component.html',
})
export class CorporateCompanyComponent implements OnInit {
  description$: Observable<string>;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    const profile$ = this.store.pipe(profileOrUndefinedIfNotLoggedIn(), finShare());
    this.description$ = profile$.pipe(
      map((profile) =>
        profile?.corporate?.userRole === CorporateUserRole.TRAVELLER
          ? 'CORPORATE.corporatePortal.companyDetails.description'
          : 'CORPORATE.corporatePortal.companyDetails.adminDescription'
      )
    );
  }
}
